// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"aK-z","smallCardRow":"bK-z","largeCardRow":"cK-z","productSearchRow":"dK-z","curatedRow":"eK-z"};